<template>
  <section class="p-1">
    <v-row class="ms-2 me-2">
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="my-card" rounded="lg" min-height="100" elevation="1">
          <v-card-text class="ps-2 pt-2">
            <a
              @click="
                $router.push({
                  path: '/CustomerFilter',
                  query: {
                    filterBy: 'KYC Pending',
                  },
                })
              "
            >
              <b class="bold indigo--text">{{
                totalPendingKYC.no_of_pending_kyc_customers
                  ? totalPendingKYC.no_of_pending_kyc_customers
                  : 0
              }}</b>
            </a>
            <br />
            <small class="black--text">Pending KYC </small><br />
            <small class="black--text">Today`s Reg Customers </small>
            <a class="ms-1 bold indigo--text" @click="todayRegcustomerList">{{
              totalUsers.no_of_today_customers
                ? totalUsers.no_of_today_customers
                : 0
            }}</a>
            <v-btn
              depressed
              fab
              color="deep-purple darken-4"
              x-small
              dark
              class="normal-cursor z-index"
            >
              <v-icon>mdi-account-supervisor-outline</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="my-cad" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <a @click="totalPushCust"
              ><b class="bold orange--text text-h6">{{
                totalpendingCust.no_of_customers
                  ? totalpendingCust.no_of_customers
                  : 0
              }}</b>
              <br />
              <small class="black--text">Push Customers </small>
            </a>
            <br />
            <small class="black--text">Today`s push Customers </small>

            <a class="ms-1 bold orange--text" @click="todayPushCust">{{
              totalpendingCust.no_of_today_customers
                ? totalpendingCust.no_of_today_customers
                : 0
            }}</a>

            <v-btn
              depressed
              fab
              color="#F9A825"
              x-small
              dark
              class="normal-cursor z-index"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="bord-primary" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <a @click="totalPushTxn"
              ><b class="bold primary--text text-h6">{{
                totalpendingTrans.no_of_txns ? totalpendingTrans.no_of_txns : 0
              }}</b>
              <br />
              <small class="black--text">Push TXN </small>
            </a>
            <br />
            <small class="black--text">Today`s push TXN </small>
            <a class="ms-1 bold primary--text" @click="todayPushTxn">{{
              totalpendingTrans.no_of_today_txns
                ? totalpendingTrans.no_of_today_txns
                : 0
            }}</a>

            <v-btn
              depressed
              fab
              color="primary"
              x-small
              dark
              class="z-index normal-cursor"
            >
              <v-icon>mdi-send-clock-outline</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="my-crd" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <b class=""
              >{{ transAmount.total_amt ? transAmount.total_amt : 0 }} MYR</b
            >
            <br />
            <small class="black--text">Transaction Amt</small><br />
            <small class="black--text">Today`s Trans Amt</small>
            <a @click="todaysTranscations" class="green--text bold ms-1"
              >{{ transAmount.today_amt ? transAmount.today_amt : 0 }}
            </a>

            <v-btn
              depressed
              fab
              color="#00E676"
              x-small
              dark
              class="z-index normal-cursor"
            >
              <v-icon>mdi-bank-transfer </v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="red-border" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <a @click="totalCompHold"
              ><b class="bold red--text text-h6"
                >{{
                  complianceHoldlist.total_compliance_hold
                    ? complianceHoldlist.total_compliance_hold
                    : 0
                }}
              </b>
              <br />
              <small class="black--text">Compliance Hold</small>
            </a>
            <br />
            <small class="black--text">Today's Compliance Hold</small>
            <a @click="todayCompHold" class="bold red--text ms-1"
              >{{
                complianceHoldlist.today_compliance_hold
                  ? complianceHoldlist.today_compliance_hold
                  : 0
              }}
            </a>

            <v-btn
              depressed
              fab
              color="red"
              x-small
              dark
              class="z-index normal-cursor"
            >
              <v-icon>mdi-account-tie-outline </v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="my-card" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <a class="ms-1 black--text" @click="PartnersCurrentdate(false)">
              <b class="bold pink--text text-h6">{{
                totalPartners.no_of_partners ? totalPartners.no_of_partners : 0
              }}</b>
            </a>
            <br />
            <small class="black--text">Total Partners</small><br />
            <small class="black--text">Today`s New Partners</small>
            <a
              class="bold pink--text ms-1"
              @click="PartnersCurrentdate(true)"
              >{{
                totalPartners.no_of_today_partners
                  ? totalPartners.no_of_today_partners
                  : 0
              }}</a
            >

            <v-btn
              depressed
              fab
              color="#e91ebd"
              x-small
              dark
              class="z-index normal-cursor"
            >
              <v-icon>mdi-handshake-outline</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col cols="12" md="4" lg="2" class="my-2">
        <v-card class="my-card" rounded="lg" min-height="100">
          <v-card-text class="ps-2 pt-2">
            <a class="ms-1 black--text" @click="PartnersCurrentdate(false)">
              <b class="bold pink--text text-h6">{{ 0 }}</b>
            </a>
            <br />
            <small class="black--text"> Domestic Payments</small><br />
            <small class="black--text w-auto">Today`s Domes Payments</small>
            <a
              class="bold pink--text ms-1"
              @click="PartnersCurrentdate(true)"
              >{{ 0 }}</a
            >

            <v-btn
              depressed
              fab
              color="#e91ebd"
              x-small
              dark
              class="z-index normal-cursor"
            >
              <v-icon>mdi-handshake-outline</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-1">
      <v-col cols="12" md="6" lg="4" class="my-2">
        <v-card class="pa-2 pb-4" rounded="lg">
          <div class="indigo--text"><b>Customers</b></div>
          <v-divider
            class="p-0 m-0 primary--text"
            inset
            color="#311B92"
          ></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="#039BE5"
                  value="100"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{ empUsers.total ? empUsers.total : 0 }}</b>
                  <p class="p-0 m-0 caption">Total</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="green darken-4"
                  :value="returnSuccess(empUsers ? empUsers : 0)"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{
                    empUsers.success ? empUsers.success : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Successfull</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="#F9A825"
                  :value="returnHold(empUsers ? empUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a @click="totalhold()" class="bold">{{
                    empUsers.hold ? empUsers.hold : 0
                  }}</a> -->
                  <b class="bold">{{ empUsers.hold ? empUsers.hold : 0 }}</b>
                  <p class="p-0 m-0 caption">Hold</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="red"
                  :value="returnRejected(empUsers ? empUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a class="bold" @click="TotalRejectedList()">{{
                    empUsers.rejected ? empUsers.rejected : 0
                  }}</a> -->
                  <b class="bold">{{
                    empUsers.rejected ? empUsers.rejected : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Rejected</p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4" class="my-2">
        <v-card class="pa-2 pb-4" rounded="lg">
          <div class="indigo--text"><b>Individual Customers</b></div>
          <v-divider
            class="p-0 m-0 primary--text"
            inset
            color="#311B92"
          ></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="9">
                <v-progress-linear
                  color="#039BE5"
                  value="100"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{ indUsers.total ? indUsers.total : 0 }}</b>
                  <p class="p-0 m-0 caption">Total</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="green darken-4"
                  :value="returnSuccess(indUsers ? indUsers : 0)"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{
                    indUsers.success ? indUsers.success : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Successfull</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="#F9A825"
                  :value="returnHold(indUsers ? indUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a @click="INDhold()" class="bold">{{
                    indUsers.hold ? indUsers.hold : 0
                  }}</a> -->
                  <b class="bold">{{ indUsers.hold ? indUsers.hold : 0 }}</b>
                  <p class="p-0 m-0 caption">Hold</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="red"
                  :value="returnRejected(indUsers ? indUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a class="bold" @click="INDRejectedList()">{{
                    indUsers.rejected ? indUsers.rejected : 0
                  }}</a> -->
                  <b class="bold">{{
                    indUsers.rejected ? indUsers.rejected : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Rejected</p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="my-2">
        <v-card class="pa-2 pb-4" rounded="lg">
          <div class="indigo--text"><b>Business Customers</b></div>
          <v-divider
            class="p-0 m-0 primary--text"
            inset
            color="#311B92"
          ></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="9">
                <v-progress-linear
                  color="#039BE5"
                  value="100"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{ busUsers.total ? busUsers.total : 0 }}</b>
                  <p class="p-0 m-0 caption">Total</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="green darken-4"
                  :value="returnSuccess(busUsers ? busUsers : 0)"
                  height="15"
                  class="mt-4"
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <b class="bold">{{
                    busUsers.success ? busUsers.success : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Successfull</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="#F9A825"
                  :value="returnHold(busUsers ? busUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a @click="BUShold()" class="bold">{{
                    busUsers.hold ? busUsers.hold : 0
                  }}</a> -->
                  <b class="bold">{{ busUsers.hold ? busUsers.hold : 0 }}</b>
                  <p class="p-0 m-0 caption">Hold</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  bg-color="black"
                  :value="returnRejected(busUsers ? busUsers : 0)"
                  height="15"
                  class="mt-4"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  <!-- <a @click="BUSRejectedList()" class="bold">{{
                    busUsers.rejected ? busUsers.rejected : 0
                  }}</a> -->
                  <b class="bold">{{
                    busUsers.rejected ? busUsers.rejected : 0
                  }}</b>
                  <p class="p-0 m-0 caption">Rejected</p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" lg="6">
        <v-card class="ps-3" rounded="lg" height="390px">
          <v-card-title class="pa-1">
            <span class="font-size">Transactions</span>
            <v-spacer></v-spacer>
            <span class="float-right">
              <v-btn-toggle
                v-model="toggle_txn"
                mandatory
                dense
                color="primary"
              >
                <v-btn @click="gettodayTotalUsers()" class="text-capitalize"
                  >Today</v-btn
                >
                <v-btn @click="gettotalTransactions()" class="text-capitalize"
                  >Total</v-btn
                >
              </v-btn-toggle>
            </span></v-card-title
          >
          <v-card-text class="">
            <apexchart
              type="bar"
              height="340"
              :options="chartbarOptions"
              :series="chartSeries"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" md="8" lg="6" class="my-4">
        <v-card class="ps-3" rounded="lg">
          <v-card-title class="pa-1">
            <span class="font-size">Transactions</span>
            <v-spacer></v-spacer>
            <span class="float-right mt-1">
              <v-btn
                depressed
                :color="!showFirstData ? 'primary' : ''"
                @click="showFirstData = false"
                plain
                class="text-capitalize"
                >Total</v-btn
              ><v-btn
                depressed
                :color="showFirstData ? 'primary' : ''"
                @click="showFirstData = true"
                plain
                class="text-capitalize"
                >Today</v-btn
              >
            </span></v-card-title
          >

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear color="#039BE5" value="100" height="15">
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div v-if="!showFirstData">
                  Total:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.total
                      : todayTotaltranscations.total
                  }}</b>
      
                </div>
                <div v-else>
                  Total:
                  <a class="black--text" @click="todaysTranscations()">
                    <b class="bold">{{
                      !showFirstData
                        ? totalTransastions.total
                        : todayTotaltranscations.total
                    }}</b>
                  </a>
            
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="green darken-4"
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.paid
                        : todayTotaltranscations.paid
                    )
                  "
                >
                </v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Paid:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.paid
                      : todayTotaltranscations.paid
                  }}</b>
         
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="yellow accent-4"
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.post
                        : todayTotaltranscations.post
                    )
                  "
                ></v-progress-linear>
              </v-col>

              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Post:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.post
                      : todayTotaltranscations.post
                  }}</b>
                 
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="#F9A825"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.hold
                        : todayTotaltranscations.hold
                    )
                  "
                  height="15"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Hold:
                  <a
                    class="bold"
                    @click="
                      $router.push({
                        path: '/TransHoldpage',
                        query: {
                          istodaytnx: !showFirstData ? false : true,
                        },
                      })
                    "
                    >{{
                      !showFirstData
                        ? totalTransastions.hold
                        : todayTotaltranscations.hold
                    }}</a
                  >
               
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="teal darken-2"
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.inprogress
                        : todayTotaltranscations.inprogress
                    )
                  "
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  In Progress:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.inprogress
                      : todayTotaltranscations.inprogress
                  }}</b>
                  
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="blue-grey "
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.failed
                        : todayTotaltranscations.failed
                    )
                  "
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Failed:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.failed
                      : todayTotaltranscations.failed
                  }}</b>
               
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="brown darken-3"
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.cancelhold
                        : todayTotaltranscations.cancelhold
                    )
                  "
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Cancel Hold:
                  <b class="bold">{{
                    !showFirstData
                      ? totalTransastions.cancelhold
                      : todayTotaltranscations.cancelhold
                  }}</b>
             
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-8 mb-2">
              <v-col cols="12" md="6" lg="9" class="d-flex">
                <v-progress-linear
                  color="red"
                  height="15"
                  :value="
                    returnProgressResult(
                      !showFirstData
                        ? totalTransastions.cancle
                        : todayTotaltranscations.cancle
                    )
                  "
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" md="6" lg="3" class="justify-center">
                <div>
                  Cancel:
                  <a @click="TransCancel" class="bold">{{
                    !showFirstData
                      ? totalTransastions.cancle
                      : todayTotaltranscations.cancle
                  }}</a>
                 
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col lg="6" md="4" cols="12">
        <v-card class="ps-3" rounded="lg" height="390px">
          <v-row no-gutters>
            <v-col lg="4" sm="12" xs="12">
              <label class="v-grap-text mt-3 m-1"> Exchange Rates </label>
            </v-col>
            <v-col lg="3" class="d-flex justify-content-end">
              <country-flag :country="selected_flag" class="mb-0 mt-3" />
              <v-select
                :items="country_list"
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectedCountry"
                item-text="text"
                item-value="value"
                solo
                flat
                class="mt-2 p-0 custome-text custome-slect-prepend"
                style="width: 30px; height: 33px; margin-bottom: 15px"
              >
                <template v-slot:item="data">
                  <template class="border">
                    <country-flag :country="data.item.value.iso2" class="m-0" />
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.text + ' ' + data.item.value.name"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-select>
            </v-col>
            <v-col lg="4" class="text-end">
              <v-btn
                depressed
                plain
                @click.prevent="onClick1Week(7)"
                :class="`${
                  no_of_days === 7 ? 'active-btn' : ''
                } v-grap-text v-grap-v-btn  `"
                id="one week"
                >1W</v-btn
              >
              <v-btn
                depressed
                plain
                @click.prevent="onClick1Week(14)"
                :class="`${
                  no_of_days === 14 ? 'active-btn' : ''
                } v-grap-text v-grap-v-btn `"
                id="one week"
                >2W</v-btn
              >
              <v-btn
                depressed
                plain
                @click.prevent="onClick1Week(30)"
                :class="`${
                  no_of_days === 30 ? 'active-btn' : ''
                } v-grap-text v-grap-v-btn `"
                id="one week"
                >30D</v-btn
              >
            </v-col>
          </v-row>
          <!-- <div id="chart">
            <apexchart
              type="bar"
              height="350"
              :options="chartOptions1"
              :series="series1"
            ></apexchart>
          </div> -->
          <apexchart
            type="area"
            height="250"
            ref="chart"
            :key="isKey"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </v-card>
      </v-col>
    </v-row>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>
<script>
import Loading from "vue-loading-overlay";
import { getspecifiedDate } from "@/utils/UsersList.js";
import commonService from "@/services/CommonService/commonService.js";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Dashboard",
  data() {
    return {
      toggle_txn: null,
      transactionseries: null,
      chartbarOptions: {
        chart: {
          type: "bar",
          toolbar: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: true,
          },
        },
        xaxis: {
          categories: [
            "Total",
            "Paid",
            "Post",
            "Hold",
            "In progress",
            "Failed",
            "Cancel Hold",
            "Cancel",
          ],
        },
      },
      chartSeries: [],
      loader: false,
      showFirstData: true,
      target_currency: "INR",
      totalUsers: [],
      totalpendingTrans: [],
      totalpendingCust: [],
      totalPendingKYC: [],
      todayRegUsers: [],
      totalTrans: [],
      transByCurrDate: [],
      transAmount: [],
      transAmountByCurDate: [],
      totalPartners: [],
      todayNewPartners: [],
      empUsers: [],
      indUsers: [],
      busUsers: [],
      country_list: [],
      totalTransastions: [],
      todayTotaltranscations: [],
      complianceHoldlist: [],
      no_of_days: 30,
      isKey: 1,
      chartOptions: {
        chart: {
          title: "Exchange Rates",
          id: "exchange-rate",
          type: "area",
          height: 350,
        },
        colors: ["#ff6b00"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
          showNullDataPoints: true,
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return this.returnLabel(value);
            },
          },
        },
        xaxis: {
          type: "datetime",
          tickAmount: 7,
        },

        tooltip: {
          x: {
            format: "dd-MM-yyyy",
          },
        },
      },

      series: [
        {
          name: "Rate",
        },
      ],
      series1: [
        {
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
        },
      ],
      chartOptions1: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "South Korea",
            "Canada",
            "United Kingdom",
            "Netherlands",
            "Italy",
            "France",
            "Japan",
            "United States",
            "China",
            "Germany",
          ],
        },
      },
      selectedCountry: {
        iso2: "IN",
        iso3: "IND",
        name: "India",
        currency: "INR",
      },
      selected_flag: "IN",
    };
  },
  watch: {
    transactionData: {
      handler(newval) {
        this.series2[0].data = newval;
      },
      immediate: true,
    },
    selectedCountry(val) {
      this.selected_flag = val.iso2;
      this.target_currency = val.currency;
      this.getExchangeRate(val.iso3);
      console.log(this.target_currency, "target_currency");
    },
  },
  created() {
    this.gettodayTotalUsers();
  },
  mounted() {
    this.getTotalPendingKYc();
    this.getTotalUsers();
    this.getTotalTrans();
    this.getTotalComplianceHold();
    this.getTransAmount();
    this.getPendingTrans();
    this.getPendingCustomers();
    this.getTotalPartners();
    this.getTotalEMPusers();
    this.getTotalINDusers();
    this.getTotalBUSusers();
    this.getExchangeRate("IND");
    this.getCountryList();
  },
  components: {
    Loading,
  },
  methods: {
    totalPushCust() {
      this.$router.push({
        path: "/pushCustomers",
        query: {
          istodaytnx: false,
        },
      });
      this.$emit("trigger-reload");
    },
    todayPushCust() {
      this.$router.push({
        path: "/pushCustomers",
        query: {
          istodaytnx: true,
        },
      });
      this.$emit("trigger-reload");
    },
    totalPushTxn() {
      this.$router.push({
        path: "/TransPush",
        query: {
          istodaytnx: false,
        },
      });
      this.$emit("trigger-reload");
    },
    todayPushTxn() {
      this.$router.push({
        path: "/TransPush",
        query: {
          istodaytnx: true,
        },
      });
      this.$emit("trigger-reload");
    },
    totalCompHold() {
      this.$router.push({
        path: "/suspiciousList",
      });
      this.$emit("trigger-reload");
    },
    todayCompHold() {
      this.$router.push({
        path: "/todaysuspiciousList",
      });
      this.$emit("trigger-reload");
    },
    returnLabel(value) {
      return `${parseFloat(value).toFixed(2)} ${this.target_currency}`;
    },
    async getCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getBeneficiaryCountryList();
        if (responseData.status === 200) {
          this.loader = false;
          responseData.data.data.map((i) => {
            this.country_list.push({
              text: i.currency_code,
              value: {
                iso2: i.isoAlpha2,
                iso3: i.isoAlpha3,
                name: i.name,
                currency: i.currency_code,
              },
            });
          });
        }
        //  else if (responseData.status === 401) {
        //   this.returnNewToken();
        //   this.getCountryList();
        // }
        console.log("responscountry", responseData);
      } catch (e) {
        console.error(e);
        this.country_list = [];
      }
    },
    adddynamictab() {
      this.$emit("slectedTab", {
        title: "List of Customers",
        path: "/compliance/CustomerList",
        close: true,
      });
    },
    onClick1Week(val) {
      this.loader = true;
      this.no_of_days = val;
      this.getExchangeRate(this.selectedCountry.iso3);
    },

    async getExchangeRate(country_code) {
      try {
        const responseData = await commonService.getrateExchage(
          country_code,
          this.no_of_days
        );
        if (responseData.status === 200) {
          this.loader = false;
          console.log("getExchangeRate22", responseData.data.data);
          this.exchange_rate = responseData.data.data;
          this.isKey = getspecifiedDate(new Date(), this.no_of_days).getTime();
          this.series[0].data =
            responseData.data.data.length > 0
              ? responseData.data.data.map((e) => {
                  return [new Date(e.created_on).getTime(), e.exchange_rate];
                })
              : [];
          console.log("this.series[0].data", this.series[0].data);
        } else {
          this.loader = false;
        }
        console.log("responscountry", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    customerList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { All_Customers: this.totalUsers.data[0] },
      });
      console.log("totalUsers", this.totalUsers.data[0]);
    },
    todayRegcustomerList() {
      this.adddynamictab();
      this.$router.push({
        name: "Customer Filter",
        query: { filterBy: "Today Register" },
      });
    },
    INDcustomerList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { IND_Customers: this.indUsers.total },
      });
    },
    BUScustomerList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { BUS_Customers: this.busUsers.total },
      });
    },
    totalTranscations() {
      this.$router.push({
        name: "Transaction",
        query: { All_transcations: this.totalTrans.data[0] },
      });
    },
    todaysTranscations() {
      this.$router.push({
        name: "Transaction Page",
        query: { Today_transcations: true },
      });
      this.$emit("trigger-reload");
    },
    totalPartnersdata() {
      this.$router.push({
        name: "Partner Summary",
        query: { Total_partners: this.totalPartners.data[0] },
      });
    },
    PartnersCurrentdate(is_today) {
      if (is_today) {
        this.$router.push("/Todaysummary");
        this.$emit("trigger-reload");
      } else {
        this.$router.push("/summary");
        this.$emit("trigger-reload");
      }
    },
    TotalRejectedList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { Totalcus_rejected: this.empUsers.rejected },
      });
      console.log("rejected", this.empUsers.rejected);
    },
    INDRejectedList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { INDCus_rejected: this.indUsers.rejected },
      });
    },
    BUSRejectedList() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { BUSCus_rejected: this.busUsers.rejected },
      });
    },
    allapproval() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { All_approval: this.empUsers.success },
      });
    },
    INDapproval() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { IND_approval: this.indUsers.success },
      });
    },
    BUSapproval() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { BUS_approval: this.busUsers.success },
      });
    },
    totalhold() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { All_hold: this.empUsers.hold },
      });
    },
    INDhold() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { IND_hold: this.indUsers.hold },
      });
    },
    BUShold() {
      this.adddynamictab();
      this.$router.push({
        name: "List of Customers",
        query: { BUS_hold: this.busUsers.hold },
      });
    },
    Transhold() {
      this.$router.push({
        name: "Transaction",
        query: { Trans_hold: this.totalTransastions.hold },
      });
    },
    TransCancel() {
      this.$router.push({
        name: "Transaction",
        query: { Trans_cancel: this.totalTransastions.cancle },
      });
    },
    returnSuccess(data) {
      if (data) {
        let result = (data.success * 100) / data.total;
        return result;
      }
    },
    returnHold(data) {
      if (data) {
        let result = (data.hold * 100) / data.total;
        return result;
      }
    },
    returnRejected(data) {
      if (data) {
        let result = (data.rejected * 100) / data.total;
        return result;
      }
    },
    returnProgressResult(data) {
      if (data) {
        const total = !this.showFirstData
          ? this.totalTransastions.total
          : this.todayTotaltranscations.total;
        let result = (data * 100) / total;
        return result;
      }
    },
    async getTotalUsers() {
      this.loader = true;
      try {
        this.loader = false;
        const responseData = await userService.getAllUsers();
        if (responseData.data.status_code === 200) {
          this.totalUsers = responseData.data.data[0];
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalUsers();
        // }
        console.log("totalusers", this.totalUsers);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    async getTotalTrans() {
      this.loader = true;
      try {
        const responseData = await userService.getAllTrans();
        if (responseData.status === 200) {
          this.totalTrans = responseData.data.data[0];
          this.loader = false;
        } else {
          this.loader = false;
        }
        console.log("totaltrans", this.totalTrans);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getTotalPendingKYc() {
      this.loader = true;
      try {
        const responseData = await userService.getKYCPendingCustomers();
        if (responseData.status === 200) {
          this.totalPendingKYC = responseData.data.data[2];
          this.loader = false;
        } else {
          this.loader = false;
        }
        console.log("totalPending", this.totalTrans);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    async getTransAmount() {
      this.loader = true;
      try {
        this.loader = false;
        const responseData = await userService.getTransAmt();
        if (responseData.data.status_code === 200) {
          this.transAmount = responseData.data.data[0];
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTransAmount();
        // }
        console.log("transAmount", this.transAmount);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    async getPendingTrans() {
      this.loader = true;
      try {
        this.loader = false;
        const responseData = await userService.getPendTrans();
        if (responseData.data.status_code === 200) {
          this.totalpendingTrans = responseData.data.data[0];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getPendingTrans();
        // }
        console.log("totalPartners", this.totalpendingTrans);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getPendingCustomers() {
      this.loader = true;
      try {
        this.loader = false;
        const responseData = await userService.getPendingCustomers();
        if (responseData.data.status_code === 200) {
          this.totalpendingCust = responseData.data.data[0];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getPendingCustomers();
        // }
        console.log("totalPartners", this.totalpendingTrans);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getTotalPartners() {
      this.loader = true;
      try {
        const responseData = await userService.getAllPartners();
        if (responseData.data.status_code === 200) {
          this.totalPartners = responseData.data.data[0];
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalPartners();
        // }
        console.log("totalPartners", this.totalPartners);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getTotalComplianceHold() {
      this.loader = true;
      try {
        const responseData = await userService.getTotalComplianceHold();
        if (responseData.data.status_code === 200) {
          this.complianceHoldlist = responseData.data.data[0];
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalPartners();
        // }
        console.log("totalPartners", this.totalPartners);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    async getTotalEMPusers() {
      this.loader = true;
      try {
        const responseData = await userService.getTotalEmpUsers();
        if (responseData.data.status_code === 200) {
          this.empUsers = responseData.data.data[0];
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalEMPusers();
        // }
        console.log("empUsers", this.empUsers);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getTotalINDusers() {
      this.loader = true;
      try {
        const responseData = await userService.getAllIndUsers();
        if (responseData.data.status_code === 200) {
          this.indUsers = responseData.data.data[0];
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalINDusers();
        // }
        console.log("empUsers", this.indUsers);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async getTotalBUSusers() {
      this.loader = true;
      try {
        const responseData = await userService.getAllBUSusers();
        if (responseData.data.status_code === 200) {
          this.busUsers = responseData.data.data[0];
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTotalBUSusers();
        // }
        console.log("empUsers", this.busUsers);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async gettotalTransactions() {
      this.loader = true;
      try {
        const responseData = await userService.getAllTransactions();
        if (responseData.data.status_code === 200) {
          this.chartSeries = [
            {
              name: "Transactions",
              data: [...Object.values(responseData.data.data[0])],
            },
          ];
          this.loader = false;
        } else {
          this.loader = false;
        }
        console.log("tik transactionData", this.transactionData);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async gettodayTotalUsers() {
      this.loader = true;
      try {
        const responseData = await userService.getTodayUsers();
        if (responseData.data.status_code === 200) {
          this.chartSeries = [
            {
              name: "Transactions",
              data: [...Object.values(responseData.data.data[0])],
            },
          ];
          this.loader = false;
        } else {
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.my-card {
  border-left: 5px solid #311b92;
}
.bord-primary {
  border-left: 5px solid $primary;
}

.my-cad {
  border-left: 5px solid #f9a825;
}

.my-crd {
  border-left: 5px solid #00e676;
}

.font-size {
  font-size: 14px;
}
.my-car {
  border-left: 5px solid #e91ebd;
}
.red-border {
  border-left: 5px solid red;
}
.red .custome-text-field .v-text-field__slot {
  font-size: 20px !important;
}
.custome-slect-prepend .v-input__slot .v-select__slot .v-select__selections {
  font-size: 16px !important;
  color: gray !important;
  padding-right: 0px !important;
}
::v-deep .margin-style-bottom {
  margin-bottom: -50px !important;
}

::v-deep .margin-style-botto {
  margin-bottom: -100px !important;
}

.margin-style-inline {
  margin-inline: -60px !important;
}

.margin style {
  margin-inline: -120px;
}
.z-index {
  position: absolute;
  top: 5px;
  right: 5px;
}
.normal-cursor {
  cursor: auto !important;
}
.bold {
  // font-weight:300;
  // color: black;
  font-size: medium;
}
</style>
